import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_GROWTH_IS_STARTER = createFcmConfig('growth_is_starter', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
